/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース画像
 * @export
 * @interface PressReleaseImage
 */
export interface PressReleaseImage {
    /**
     * 画像ファイル名
     * @type {string}
     * @memberof PressReleaseImage
     */
    fileName: string;
    /**
     * 画像ファイル名(s3)
     * @type {string}
     * @memberof PressReleaseImage
     */
    fileNameS3: string;
    /**
     * 見出し
     * @type {string}
     * @memberof PressReleaseImage
     */
    caption?: string | null;
}

export function PressReleaseImageFromJSON(json: any): PressReleaseImage {
    return PressReleaseImageFromJSONTyped(json, false);
}

export function PressReleaseImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'fileNameS3': json['file_name_s3'],
        'caption': !exists(json, 'caption') ? undefined : json['caption'],
    };
}

export function PressReleaseImageToJSON(value?: PressReleaseImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'file_name_s3': value.fileNameS3,
        'caption': value.caption,
    };
}

